import { PAC_AGENTS_ACTIONS } from "Store/actions/pacAgentsActions";

const initialState = {
    selectedVersionWithAgents: null,
    selectedVersionPrdData: null,
    selectedVersionJdData: null,
}

const pacAgentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case PAC_AGENTS_ACTIONS.SET_SELECTED_VERSION_WITH_AGENTS:
            return {
                ...state,
                selectedVersionWithAgents: action.payload,
            }
        case PAC_AGENTS_ACTIONS.CLEAR_SELECTED_VERSION_WITH_AGENTS:
            return {
                ...state,
                selectedVersionWithAgents: null,
            }
        case PAC_AGENTS_ACTIONS.SET_SELECTED_VERSION_PRD_DATA:
            return {
                ...state,
                selectedVersionPrdData: action.payload,
            }
        case PAC_AGENTS_ACTIONS.CLEAR_SELECTED_VERSION_PRD_DATA:
            return {
                ...state,
                selectedVersionPrdData: null,
            }
        case PAC_AGENTS_ACTIONS.SET_SELECTED_VERSION_JD_DATA:
            return {
                ...state,
                selectedVersionJdData: action.payload,
            }
        case PAC_AGENTS_ACTIONS.CLEAR_SELECTED_VERSION_JD_DATA:
            return {
                ...state,
                selectedVersionJdData: null,
            }
        default:
            return state;
    }
}

export default pacAgentsReducer;